import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';

import type { RequisitionFlow } from '@recruitee/requisitions-types';

import type { RequisitionsAbilities } from '../../data/list/requisitions-list-data.service';
import { RequisitionsListDataService } from '../../data/list/requisitions-list-data.service';

@Injectable()
export class RequisitionsListFacade {
  private abilities: RequisitionsAbilities;
  private flows: RequisitionFlow[];
  private defaultFlowMissing: boolean;

  private ngOnDestroy$ = new Subject<void>();

  constructor(
    protected store: Store,
    protected requisitionsData: RequisitionsListDataService,
  ) {
    requisitionsData.data$
      .pipe(takeUntil(this.ngOnDestroy$))
      .subscribe(({ abilities, flows, defaultFlowIsMissing }) => {
        this.flows = flows;
        this.abilities = abilities;
        this.defaultFlowMissing = defaultFlowIsMissing;
      });
  }

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public get hasCreatedFlows(): boolean {
    return !!this.flows.length;
  }

  public get isDefaultFLowMissing(): boolean {
    return this.defaultFlowMissing;
  }

  public get canEditRequisitions(): boolean {
    return this.abilities.manageRequisitions;
  }

  public get canCreateRequisitions(): boolean {
    return this.abilities.manageRequisitions && this.hasCreatedFlows;
  }

  public get canCreateJobs(): boolean {
    return this.abilities.manageJobs;
  }

  public get canManageRequisitionsSettings(): boolean {
    return this.abilities.manageCompany;
  }
}
